




























































































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';

import DatePicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { vxm } from '@/store.vuex';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';

declare var window:any;

@Component({
  name: 'EducationHistory',
  components: {
    DatePicker,
    VueGoogleAutocomplete,
    ProfilePlaceholder,
    AddEntity
  },
})
export default class EducationHistory   extends Mixins(GuidedSignupUtilities) {
  $refs!: {
    'education-history-location': HTMLFormElement;
  };
  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop() isLastStep;

  $moment: any;
  $wlToastr: any;
  private showForm = false;
  private selectedItem;
  private school = '';
  private degree = '';
  private completionDate: string | Date = '';
  private location = '';
  private city = '';
  private state = '';
  private country = '';
  private gpa = '';
  private major = '';
  private startDate = '';
  private gpaOutOf = '';

  private errors = {
    school: '',
    location: '',
    gpa: '',
    degree: '',
    startDate: '',
    gpaOutOf: '',
    completionDate: '',
  };

  onDeleteorBackSpace() {
    if (!this.$refs['education-history-location'].$el._value) {
      this.location = ''
    }
  }

  @Watch('educationHistoryList')
  educationHistoryListChange(newVal, oldVal) {
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep
    ? newVal.length < this.minimumEntries : this.isRequiredStep) : newVal.length === 0;
    this.$emit('disable-next-button', disable);
  }

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  mounted() {
    this.bus.$on('on-next-step', this.onNextStep);
    console.log("education history");
    vxm.users.getProfileStrength();
    vxm.users.listEducationHistory();
    vxm.users.fetchDegreeOptions();
  }

  async onNextStep() {
    await vxm.users.validateMandatorySteps();
    if (vxm.users.MissedMandatorySteps.length && this.isLastStep) {
           this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
    }else{
        this.$emit('go-to-next');
    }
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  validateGpa() {
    if (Number(this.gpa)) {
      this.gpa = Number(this.gpa).toFixed(1);
    } else {
      this.gpa = '';
    }
  }

  validateGpaOutOf() {
    if (Number(this.gpaOutOf)) {
      this.gpaOutOf = Number(this.gpaOutOf).toFixed(1);
    } else {
      this.gpaOutOf = '';
    }
  }
  get showEducationDates() {
    return !vxm.configs.getGlobalConfigValue('HIDE_EDUCATION_HISTORY_DATES');
  }

  get showOverallResultGpa(){
    return !vxm.configs.getGlobalConfigValue('HIDE_EDUCATION_HISTORY_OVERALL_RESULT_GPA');
  }
  
  onTypingAddress({ newVal = '' } = {}) {
    if (!newVal) {
      this.location = '';
      this.city = '';
      this.country = '';
      this.state = '';
    }
  }

  get educationHistoryList() {
    return vxm.users.EducationHistoryList;
  }

  get degreeOptions() {
    return vxm.users.DegreeOptions;
  }

  get isMyProfile() {
    var str = this.$route.path!;
    return str.includes('myprofile/v2');
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat || '';
  }

  getClass() {
    return {
      'm-3': this.isMyProfile,
      'my-5': !this.isMyProfile,
    };
  }

  async saveEducationHistory() {
    const isInvalid = this.validateEducationHistoryForm();
    if (isInvalid) {
      return;
    }
    const payload = {
      school: this.school,
      degree: this.degree,
      startDate:
        (this.startDate &&
          vxm.utility.convertLocalTimeToUTC(new Date(this.startDate))) ||
        null,
      completionDate:
        (this.completionDate &&
          vxm.utility.convertLocalTimeToUTC(new Date(this.completionDate))) ||
        null,
      city: this.city,
      state: this.state,
      country: this.country,
      candidateEducationHistoryId: this.selectedItem,
      gpa: this.gpa,
      major: this.major,
      gpaOutOf: this.gpaOutOf,
    };
    try {
      const response = this.selectedItem
        ? await vxm.users.updateEducationHistory(payload)
        : await vxm.users.saveEducationHistory(payload);
      vxm.users.getProfileStrength();
      vxm.users.listEducationHistory();
      vxm.users.Rudderstack.trackEvent("Education History Updated", {EducationHistoryDetails : payload})
      this.$wlToastr(
        'success',
        this.selectedItem
          ? this.$t('education.history.updated').toString()
          : this.$t('education.history.updated').toString(),
        this.$t('EducationHistory_EducationHistory').toString(),
      );
      this.showForm = false;
      this.state = '';
      this.country = '';
      this.city = '';
    } catch (e) {
      this.$wlToastr('error', this.$t('something.went.wrong').toString(), this.$t('please.try.again').toString());
    }
  }
  get sectionSubHeader(){
    if( this.minimumEntries>1 && this.userPermissionConfig('edit')){
      return `You need to add at least ${
          this.minimumEntries
        } levels of education history`
    }
   return ''
 }
 get isConfigEnabled(){
      if(window.WorkLLama.isConfigJSONEnabled==='true'){
        return true
      }
      return false
      }
  validateEducationHistoryForm() {
    this.school = this.school.trim()
    this.major = this.major.trim()
    this.errors = {
      school: this.school ? '' : this.$t('this.field.required').toString(),
      location: this.location && this.city ? '' : this.$t('EducationHistory_EnterCity').toString(),
      degree: this.degree ? '' : this.$t('this.field.required').toString(),
      gpa: this.showOverallResultGpa ? (!this.gpa && this.gpaOutOf ? this.$t('this.field.required').toString() : '') : '',
      gpaOutOf: this.gpa && !this.gpaOutOf ? this.$t('this.field.required').toString() : '',
      startDate:
        !this.startDate && this.completionDate ? this.$t('this.field.required').toString() : '',
      completionDate:
        this.startDate && !this.completionDate ? this.$t('this.field.required').toString() : '',  
    };
    if (this.gpa && this.gpaOutOf && Number(this.gpa) > Number(this.gpaOutOf)) {
      this.errors.gpa = this.$t('gpa.less.than.max').toString();
    } else if (Number(this.gpaOutOf) > 100) {
      this.errors.gpaOutOf = this.$t('value.not.more.than.hundred').toString();
    }
    if (
      this.startDate &&
      this.completionDate &&
      this.startDate >= this.completionDate
    ) {
      this.errors.startDate = this.$t('start.date.less.than.end.date').toString();
    }
    const isInvalid = Object.keys(this.errors).some((entity) => {
      return this.errors[entity];
    });
    return isInvalid;
  }
  editEducationHistory(id) {
    this.errors = {
      school: '',
      location: '',
      gpa: '',
      degree: '',
      startDate: '',
      gpaOutOf: '',
      completionDate: '',
    };
    this.showForm = true;
    const selectedItem = this.educationHistoryList.find(
      (history) => history.candidateEducationHistoryId === id,
    );
    if (!selectedItem) {
      return;
    }
    this.school = selectedItem.school || '';
    this.degree = selectedItem.degree || '';
    this.completionDate = selectedItem.completionDate;
    this.city = selectedItem.city || '';
    this.country = selectedItem.country || '';
    this.state = selectedItem.state || '';
    this.location = `${this.city}${this.state ? ',' : ''}${this.state}${this.country ? ',' : ''}${
      this.country
    }`;
    this.selectedItem = selectedItem.candidateEducationHistoryId;
    this.major = selectedItem.major || '';
    this.startDate = selectedItem.startDate;
    this.gpa = selectedItem.gpa;
    this.gpaOutOf = selectedItem.gpaOutOf;
  }
  createNewHistory() {
    this.errors = {
      school: '',
      location: '',
      gpa: '',
      degree: '',
      startDate: '',
      gpaOutOf: '',
      completionDate: '',
    };
    this.showForm = true;
    this.school = '';
    this.degree = '';
    this.completionDate = '';
    this.location = '';
    this.city = '';
    this.state = '';
    this.country = '';
    this.gpa = '';
    this.gpaOutOf = '';
    this.major = '';
    this.startDate = '';
    this.selectedItem = null;
  }
  confirmDeleteEducationHistory(id) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('delete.education.history').toString(),
        body: this.$t('are.you.sure.you.want.to.delete').toString(),
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          this.deleteEducationHistory(id);
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  async deleteEducationHistory(id) {
    await vxm.users.deleteEducationHistory(id);
    vxm.users.getProfileStrength();
    vxm.users.listEducationHistory();
    this.$wlToastr(
      'success',
      this.$t('education.history.deleted.succesfully').toString() ,
      this.$t('EducationHistory_EducationHistory').toString(),
    );
  }
  setSelectedLocation(address, addressInfo) {
    const addressComponent =
      addressInfo.address_components.find(
        (component) =>
          component.short_name === address.administrative_area_level_1,
      ) || {};
    this.state =
      addressComponent.long_name || address.administrative_area_level_1;
    this.country = address.country;
    this.city = address.locality || '';
    this.location = `${this.city},${this.state},${this.country}`;
  }

  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'EDUCATION_HISTORY');
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'EDUCATION_HISTORY',
      );
      return section ? section.displayName : 'Education History';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'EDUCATION_HISTORY',
    );
    return section ? section.displayName : 'Education History';
  }

  isAlphabet(e) {
    let char = String.fromCharCode(e.keyCode); // Get the character
    if (/^[A-Za-z\'\ \.\,]+$/.test(char)) return true;
    // Match with regex
    else e.preventDefault(); // If not match, don't add to input text
    return;
  }
}
